import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { FormsConstructorModule } from 'src/app/forms/forms-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { GeocodingLocationProvider } from '../../forms/fields/components/location-form-field/geocoding/geocoding-location-provider/geocoding-location.provider';
import { MultipleSearchMapFormFieldService } from '../../forms/fields/components/multiple-search-map-form-field/helpers/multiple-search-map-form-field.service';
import { ProfileService } from '../profile/profile.service';
import { MarkerEventDirective } from './directives/marker-event.directive';
import { MapContainerComponent } from './map-container/map-container.component';
import { MapMarkService } from './map-marker.service';
import { MapComponent } from './map.component';
import { AggregatedMarkerComponent } from './marker-info/aggregated-marker/aggregated-marker.component';
import { CommunityProjectMarkerComponent } from './marker-info/community-project-marker/community-project-marker.component';
import { MarkerInfoDirective } from './marker-info/marker-info.directive';
import { MarkerInfoFactory } from './marker-info/marker-info.factory';
import { UserMarkerComponent } from './marker-info/user-marker/user-marker.component';
import { MapGotoBlockComponent } from './search-block/map-goto-block/map-goto-block.component';
import { CommunityProjectResultComponent } from './search-block/map-search-results/map-search-result/community-project-result/community-project-result.component';
import { MapSearchResultDirective } from './search-block/map-search-results/map-search-result/map-search-result.directive';
import { MapSearchResultFactory } from './search-block/map-search-results/map-search-result/map-search-result.factory';
import { UserResultComponent } from './search-block/map-search-results/map-search-result/user-result/user-result.component';
import { MapSearchResultsComponent } from './search-block/map-search-results/map-search-results.component';
import { SearchBlockComponent } from './search-block/search-block.component';
import { SelectedFiltersBlockComponent } from './selected-filters-block/selected-filters-block.component';
import { SubNavigationComponent } from './sub-navigation/sub-navigation.component';
import { UsersTotalComponent } from './users-total/users-total.component';

@NgModule({
  imports: [SharedModule, PipesModule, FormsConstructorModule, BrowserAnimationsModule, GoogleMapsModule],
  declarations: [
    MarkerEventDirective,
    MapComponent,
    MapContainerComponent,
    UsersTotalComponent,
    SubNavigationComponent,
    CommunityProjectMarkerComponent,
    UserMarkerComponent,
    AggregatedMarkerComponent,
    MarkerInfoFactory,
    MarkerInfoDirective,
    UserMarkerComponent,
    SearchBlockComponent,
    MapGotoBlockComponent,
    MapSearchResultsComponent,
    MapSearchResultFactory,
    MapSearchResultDirective,
    UserResultComponent,
    CommunityProjectResultComponent,
    SelectedFiltersBlockComponent,
  ],
  providers: [MultipleSearchMapFormFieldService, MapMarkService, ProfileService, GeocodingLocationProvider],
})
export class MapModule {
  public static forRoot(): ModuleWithProviders<MapModule> {
    return { ngModule: MapModule };
  }
}
